import React, {useEffect, useState} from 'react'
import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL || ''

function getToken(): string | null {
  try {
    const a = localStorage.getItem('kt-auth-react-v')
    return a ? JSON.parse(a)?.api_token || null : null
  } catch {
    return null
  }
}

// Monthly, dismissible promo about the new "invite a friend → free month" program.
// Self-checks eligibility via GET /api/referral-promo (active + paid customers,
// once a month). Admins can preview it anywhere with ?preview_referral_promo=1.
export const ReferralPromoPopup: React.FC = () => {
  const [show, setShow] = useState(false)
  const [code, setCode] = useState('')
  const [copied, setCopied] = useState(false)
  const preview =
    typeof window !== 'undefined' &&
    (() => {
      const p = new URLSearchParams(window.location.search)
      return p.has('preview_referral_promo') || p.has('preview-referral-promo')
    })()

  useEffect(() => {
    const token = getToken()
    // Only real clients see it — never an admin (even while impersonating), unless previewing.
    const isAdmin = typeof window !== 'undefined' && !!localStorage.getItem('admin_auth_token')
    if (isAdmin && !preview) return
    if (!token && !preview) return
    const headers: Record<string, string> = {}
    if (token) headers.Authorization = `Bearer ${token}`
    axios
      .get(`${API_URL}/api/referral-promo`, {headers})
      .then((r) => {
        setCode(r.data?.affiliate_code || (preview ? 'YOURCODE' : ''))
        if (preview) {
          setShow(true)
          return
        }
        if (r.data?.show) {
          setShow(true)
          // Record the view now — advances the daily→monthly pacing.
          if (token) axios.post(`${API_URL}/api/referral-promo/seen`, {}, {headers}).catch(() => {})
        }
      })
      .catch(() => {
        if (preview) {
          setCode('YOURCODE')
          setShow(true)
        }
      })
  }, [preview])

  if (!show) return null

  const link = `${window.location.origin}/auth/register?aff=${code}`

  const dismiss = () => setShow(false)
  const copy = () => {
    navigator.clipboard.writeText(link)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }
  const wa = `https://wa.me/?text=${encodeURIComponent('הצטרפו ל-FBZipper דרך הלינק שלי: ' + link)}`

  return (
    <div
      onClick={(e) => {
        if (e.target === e.currentTarget) dismiss()
      }}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(4px)',
        zIndex: 100001, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px',
      }}
    >
      <div style={{background: '#fff', borderRadius: '16px', maxWidth: '480px', width: '100%', overflow: 'hidden', boxShadow: '0 25px 50px rgba(0,0,0,0.25)', direction: 'rtl'}}>
        <div style={{background: 'linear-gradient(135deg,#f59e0b 0%,#d97706 100%)', padding: '24px', color: '#fff', textAlign: 'center', position: 'relative'}}>
          <button onClick={dismiss} style={{position: 'absolute', top: '12px', left: '12px', width: '32px', height: '32px', borderRadius: '50%', border: 'none', background: 'rgba(255,255,255,0.2)', color: '#fff', cursor: 'pointer', fontSize: '16px'}}>✕</button>
          <div style={{fontSize: '40px', marginBottom: '8px'}}>🎁</div>
          <h2 style={{margin: 0, fontSize: '22px', fontWeight: 800}}>חדש! הזמן חבר וקבל חודש חינם</h2>
          <p style={{margin: '8px 0 0', opacity: 0.95, fontSize: '14px', lineHeight: 1.6}}>
            על כל חבר שמצטרף דרך הלינק שלך ומבצע תשלום ראשון — מתווסף לך חודש חינם אוטומטית!
          </p>
        </div>
        <div style={{padding: '24px'}}>
          <div style={{background: '#fff7ed', border: '1px solid #fed7aa', borderRadius: '12px', padding: '16px', marginBottom: '20px'}}>
            <div style={{fontWeight: 700, fontSize: '14px', color: '#9a3412', marginBottom: '8px'}}>איך זה עובד? 📋</div>
            <ol style={{margin: 0, paddingInlineStart: '18px', fontSize: '13px', color: '#374151', lineHeight: 1.9}}>
              <li>שתפו את הלינק האישי שלכם (למטה) עם חברים.</li>
              <li>החבר נרשם דרך הלינק ומקבל 14 יום ניסיון חינם — <b>ללא כרטיס אשראי וללא התחייבות</b>.</li>
              <li>כשהחבר מבצע את התשלום הראשון — מתווסף לכם <b>חודש חינם</b> אוטומטית לחשבון.</li>
              <li>אין הגבלה — חודש חינם על כל חבר שמצטרף ומשלם! 🎁</li>
            </ol>
          </div>
          <div style={{fontSize: '13px', fontWeight: 600, color: '#374151', marginBottom: '8px'}}>הלינק האישי שלך</div>
          <div style={{display: 'flex', gap: '8px', marginBottom: '16px'}}>
            <input readOnly value={link} style={{flex: 1, padding: '10px 14px', background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: '8px', fontSize: '13px', color: '#374151', direction: 'ltr', textAlign: 'left'}} />
            <button onClick={copy} style={{padding: '10px 18px', background: copied ? '#16a34a' : '#2b70fa', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 600, cursor: 'pointer', fontSize: '13px', whiteSpace: 'nowrap'}}>{copied ? '✓ הועתק' : 'העתק'}</button>
          </div>
          <a href={wa} target="_blank" rel="noreferrer" style={{display: 'block', textAlign: 'center', padding: '12px', background: '#25D366', color: '#fff', borderRadius: '8px', fontWeight: 700, textDecoration: 'none', marginBottom: '10px'}}>שתף בוואטסאפ</a>
          <button onClick={dismiss} style={{width: '100%', padding: '10px', background: 'transparent', border: 'none', color: '#9ca3af', cursor: 'pointer', fontSize: '13px'}}>אולי מאוחר יותר</button>
        </div>
      </div>
    </div>
  )
}
